import React from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';

import MainLayout from '../../components/Layout/MainLayout';
import EmptyState from '../../components/shared/EmptyState';
import { useApi } from '../../hooks/useApi';

import SellerHeader from './components/SellerHeader';
import FeaturedItems from './components/FeaturedItems';
import FullInventory from './components/FullInventory';
import { PageWrapper } from './styles';

export default function Seller() {
  const { id } = useParams();
  const { data: seller, loading } = useApi(`/sellers/${id}`);

  if (loading) {
    return (
      <MainLayout showSidebar={false}>
        <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />
      </MainLayout>
    );
  }

  if (!seller) {
    return (
      <MainLayout showSidebar={false}>
        <EmptyState
          description="Vendedor no encontrado"
          actionText="Volver al inicio"
          actionLink="/"
        />
      </MainLayout>
    );
  }

  return (
    <MainLayout showSidebar={false}>
      <PageWrapper>
        <SellerHeader seller={seller} />
        <FeaturedItems featuredBookIds={seller.featuredBookIds} sellerId={seller.id} />
        <FullInventory sellerId={seller.id} />
      </PageWrapper>
    </MainLayout>
  );
}
